<template>
    <div>
        <div class="createProjectListSidebarContentWrapper" v-if="task._id">
            <a href="#" @click.prevent="scrollToBottom" class="btn-scroll-to-bottom" :style="{paddingBottom: checkApps('tags') ? '15px' : ''}" v-if="clientWidth < 767">
                {{$t('general.scroll_to_bottom')}}
            </a>
            <div class="d-flex mobile__bg--withPadding" v-if="checkApps('tags')">
                <div class="d-flex align-items-center overflow-auto style-scroll tagList__main-wrapper-sidebar pb-1px">
                    <div v-for="(item, index) in tagChipArray" :key="index" @click.stop="">
                        <div class="tagList taglist__mobile-margin">
                            <TagChip  :data="item" :isBorder="false" :ids="ids"  :tagsArray="projectData.tagsArray" :prjectGlobalPermission="canEditKpiTask && projectData?.isGlobalPermission" :taskId="task._id" :sprintId="task.sprintId" :taskName="task.TaskName"/>
                        </div>
                    </div>
                </div>
                <template v-if="canEditKpiTask && checkPermission('task.task_tag',projectData?.isGlobalPermission) !== null">
                    <CreateTagPopup :task="task" @send:tagChipArray="(val)=>tagChipArray = val"  @send:ids="(val)=>ids = val" :project="projectData" :isTaskList="false" />
                </template>
            </div>
            <div
                v-if="checkPermission('task.task_description',projectData?.isGlobalPermission) !== null && checkApps('AI',projectData) !== undefined && checkPermission('task.task_description',projectData?.isGlobalPermission) !== undefined && Object.keys(projectData).length > 0"
                class="task-detail-collapse-section"
            >
                <button class="task-detail-collapse-header" type="button" @click="toggleSection('description')">
                    <img :src="arrowDownFillIcon" :class="['task-detail-collapse-caret', { 'is-collapsed': collapsedSections.description }]" alt="toggle" />
                    <span>{{ $t('ProjectDetails.description') }}</span>
                </button>
                <div v-show="!collapsedSections.description" class="task-detail-collapse-body">
                    <Description
                        :isShowAi="canEditKpiTask && checkApps('AI',projectData) && checkPermission('task.task_description',projectData?.isGlobalPermission) == true"
                        :description="task?.descriptionBlock ? task.descriptionBlock : task.description"
                        :editPermission="canEditKpiTask && checkPermission('task.task_description',projectData?.isGlobalPermission)"
                        :minlength="10"
                        :projectData="projectData"
                        :from="'task'"
                        class="description-comp"
                        :task="task"
                    />
                </div>
            </div>
            <div
                v-if="(canCreateNestedSubtask || Number(task.subTasks) > 0 || subTasksArray.length > 0) && checkPermission('task.sub_task_create',projectData?.isGlobalPermission) !== null"
                class="task-detail-collapse-section"
            >
                <div class="task-detail-collapse-header" role="button" tabindex="0" @click="toggleSection('subtasks')" @keyup.enter="toggleSection('subtasks')">
                    <img :src="arrowDownFillIcon" :class="['task-detail-collapse-caret', { 'is-collapsed': collapsedSections.subtasks }]" alt="toggle" />
                    <span>{{ $t('ProjectDetails.subtask') }}</span>
                    <span class="task-detail-collapse-count">{{ subTasksArray.length }}</span>
                    <button
                        v-if="canCreateNestedSubtask && canEditKpiTask && checkPermission('task.sub_task_create',projectData?.isGlobalPermission) === true"
                        type="button"
                        class="task-detail-collapse-action"
                        @click.stop="requestSubtaskCreate"
                    >
                        + {{$t('Projects.add_subtask')}}
                    </button>
                </div>
                <div v-show="!collapsedSections.subtasks" class="task-detail-collapse-body">
                    <SubTasks
                        :task="task"
                        class="mt-1"
                        :parentAssignee="task.AssigneeUserId"
                        :subTasksArray="subTasksArray"
                        :hideHeader="true"
                        :createTrigger="subtaskCreateTrigger"
                    />
                </div>
            </div>
            <div
                v-if="checkPermission('task.task_custom_field',projectData?.isGlobalPermission) !== null && checkApps('CustomFields')"
                class="task-detail-collapse-section position-re"
            >
                <div class="task-detail-collapse-header" role="button" tabindex="0" @click="toggleSection('customFields')" @keyup.enter="toggleSection('customFields')">
                    <img :src="arrowDownFillIcon" :class="['task-detail-collapse-caret', { 'is-collapsed': collapsedSections.customFields }]" alt="toggle" />
                    <span>{{ $t('CustomField.custom_field') }}</span>
                    <button
                        v-if="canEditKpiTask && checkPermission('task.task_custom_field',projectData?.isGlobalPermission) === true && currentCompany?.planFeature?.customFields"
                        type="button"
                        class="task-detail-collapse-action"
                        @click.stop="requestCustomFieldCreate"
                    >
                        + {{$t('CustomField.custom_field')}}
                    </button>
                </div>
                <div v-show="!collapsedSections.customFields" class="task-detail-collapse-body">
                    <div class="position-re">
                        <div>
                            <div :class="[{'pointer-event-none opacity-5 blur-3-px':!currentCompany?.planFeature?.customFields}]">
                                <CustomFieldRenderViewComponent
                                    @blurUpdate="submitHandler"
                                    @editCustomField="editCustomField"
                                    :task="props.task"
                                    @isCustomField="isCustomField = true"
                                    :editPermission="canEditKpiTask && checkPermission('task.task_custom_field',projectData?.isGlobalPermission)"
                                    :planPermission="currentCompany?.planFeature?.customFields"
                                    :hideHeader="true"
                                />
                            </div>
                            <div v-if="!currentCompany?.planFeature?.customFields">
                                <UpgradePlan
                                :isImage="false"
                                :buttonText="$t('Upgrades.upgrade_your_plan')"
                                :lastTitle="$t('Upgrades.unlock_custom_field')"
                                :secondTitle="$t('Upgrades.unlimited')"
                                :firstTitle="$t('Upgrades.upgrade_to')"
                                :message="$t('Upgrades.the_feature_not_available')"
                        />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="checkPermission('task.task_checklist',projectData?.isGlobalPermission) !== null"
                class="task-detail-collapse-section"
            >
                <div class="task-detail-collapse-header" role="button" tabindex="0" @click="toggleSection('checklist')" @keyup.enter="toggleSection('checklist')">
                    <img :src="arrowDownFillIcon" :class="['task-detail-collapse-caret', { 'is-collapsed': collapsedSections.checklist }]" alt="toggle" />
                    <span>{{ $t('Checklist.checklist') }}</span>
                    <span class="task-detail-collapse-count">{{ checkList?.length || 0 }}</span>
                    <button
                        v-if="canEditKpiTask && checkPermission('task.task_checklist',projectData?.isGlobalPermission) === true"
                        type="button"
                        class="task-detail-collapse-action"
                        @click.stop="requestChecklistCreate"
                    >
                        + {{$t('Checklist.add_checklist')}}
                    </button>
                </div>
                <div v-show="!collapsedSections.checklist" class="task-detail-collapse-body">
                    <CheckListComponent
                        :taskId="task._id"
                        :sprintId="task.sprintId"
                        :data="checkList"
                        :task="task"
                        :permission="canEditKpiTask && checkPermission('task.task_checklist',projectData?.isGlobalPermission) === true"
                        :isSpinnerAi="isSpinnerAi"
                        :planCondition="currentCompany?.planFeature?.checkList ?? currentCompany?.planFeature?.taskCheckList"
                        :hideHeader="true"
                        :hideCreateAction="true"
                        :createTrigger="checklistCreateTrigger"
                    />
                </div>
            </div>
            <div
                v-if="checkPermission('task.task_attachments',projectData?.isGlobalPermission) !== null"
                class="task-detail-collapse-section"
            >
                <div class="task-detail-collapse-header" role="button" tabindex="0" @click="toggleSection('attachments')" @keyup.enter="toggleSection('attachments')">
                    <img :src="arrowDownFillIcon" :class="['task-detail-collapse-caret', { 'is-collapsed': collapsedSections.attachments }]" alt="toggle" />
                    <span>{{ $t('Attachments.attachments') }}</span>
                    <span class="task-detail-collapse-count">{{ task.attachments?.length || 0 }}</span>
                    <button
                        v-if="canEditKpiTask && checkPermission('task.task_attachments',projectData?.isGlobalPermission) === true"
                        type="button"
                        class="task-detail-collapse-action"
                        @click.stop="requestAttachmentCreate"
                    >
                        + {{$t('Attachments.attachments')}}
                    </button>
                </div>
                <div v-show="!collapsedSections.attachments" class="task-detail-collapse-body">
                    <Attachments
                        class="mt-20px"
                        :permission="canEditKpiTask && checkPermission('task.task_attachments',projectData?.isGlobalPermission)"
                        :attachments="task.attachments"
                        :extensions="fileExtentions"
                        @update:add="(files) => newAttachments(files)"
                        @update:delete="(file) => deleteAttachments(file)"
                        @seAll="(val)=>{openSeeAll(val)}"
                        :isSpinner="isSpinner"
                        :selectedData="task"
                        :hideHeader="true"
                        :addTrigger="attachmentCreateTrigger"
                    />
                </div>
            </div>
        </div>
    </div>
    <CustomFieldsSidebarComponent
        @customFieldStore="customFieldStore"
        @closeSidebar="handleCloseSidebar"
        :componentDetail="componentDetail && Object.keys(componentDetail).length ? componentDetail : {}"
        :customFieldObject="componentDetail && Object.keys(componentDetail).length ? customFieldObject : {}"
        :isCustomField="isCustomField"
        :compact="true"
        @handleClose="handleClose()"
    />
    <PromptSidebar v-if="isOpenPromptDeatil" @closePrompt="isOpenPromptDeatil = false" :selectedPrompt="selectedPrompt" @closeMainSidebar="isOpenPromptDeatil = false" :project="projectData" :task="task" />
</template>

<script setup>
// PACKAGES
import Swal from 'sweetalert2';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { computed, defineProps, inject, ref, nextTick,onMounted, watch } from 'vue';

// COMPONENTS
import { dbCollections } from '@/utils/Collections';
import Description from '@/components/atom/Description/Description.vue'
import Attachments from '@/components/atom/Attachments/Attachments.vue'
import CheckListComponent from '@/components/molecules/CheckList/CheckList.vue'
import SubTasks from '@/components/organisms/SubTasks/SubTasks.vue'
import CreateTagPopup from "@/components/molecules/TagList/CreateTagPopup.vue";
import TagChip from '@/components/atom/TagChip/TagChip.vue'
import PromptSidebar from "@/components/molecules/PromptSidebar/PromptSidebar.vue";
import arrowDownFillIcon from "@/assets/images/svg/arrow_down_fill.svg";
import { apiRequest, apiRequestWithoutCompnay } from '../../../services';
import * as env from '@/config/env';
import axios from 'axios';

// UTILS
import { useCustomComposable, useGetterFunctions } from '@/composable';
import taskClass from '@/utils/TaskOperations';
import UpgradePlan from '@/components/atom/UpgradYourPlanComponent/UpgradYourPlanComponent.vue';
import {storageQueryBuilder,generateFileName} from '@/utils/storageQueryBuild.js';
import { useI18n } from 'vue-i18n';


const $toast = useToast();
const {t} = useI18n();
const { getters,commit } = useStore();
const { getUser } = useGetterFunctions();
const { checkPermission, makeUniqueId, checkBucketStorage,checkApps } = useCustomComposable();

// props
const props = defineProps({
    task: {
        type: Object,
        required: true,
    },
    isSupport:{
        type:Boolean,
        default:false
    },
    subTasksArray: {
        type: Array,
        default: () => []
    },
    canEditKpiTask: {
        type: Boolean,
        default: true
    }
});

// emit
const emit = defineEmits(["openSeeAll"]);

//computed
const fileExtentions = computed(() => {
    return getters['settings/fileExtentions'];
});
const companyOwner = computed(() => {
    return getters["settings/companyOwnerDetail"];
});
const checkList = computed(() => props.task.checklistArray);
const canCreateNestedSubtask = computed(() => {
    const maxDepth = Number(env.MAX_NESTED_TASK_DEPTH || 6);
    return Number(props.task?.nestedDepth || 1) < maxDepth;
});
const currentCompany = computed(() => getters["settings/selectedCompany"]);
const projectsGetter = computed(() => getters["projectData/onlyActiveProjects"]);
const showCustomField = computed(() => checkPermission("task.task_custom_field", projectData.value?.isGlobalPermission, {gettersVal: getters}));

// ref
const ids = ref();
const tagChipArray = ref();
const isSpinner = ref(false);
const submitted = ref(false);
const componentDetail = ref({});
const customFieldObject = ref({});
const isCustomField = ref(false);
const allProjectsArrayFilter = ref([]);
const CustomFieldData = ref(JSON.parse(JSON.stringify(getters["settings/customFields"])));
const selectedProject = ref([])
const isOpenPromptDeatil = ref(false);
const selectedPrompt = ref({})
const isSpinnerAi = ref(false);
const collapsedSections = ref({
    description: false,
    subtasks: false,
    customFields: true,
    checklist: false,
    attachments: false,
});
const subtaskCreateTrigger = ref(0);
const checklistCreateTrigger = ref(0);
const attachmentCreateTrigger = ref(0);

// inject
const userId = inject('$userId');
const companyId = inject('$companyId');
const clientWidth = inject("$clientWidth");
const projectData = inject("selectedProject");

//getUser
const user = getUser(userId.value);

onMounted(() => {
    let data = {
        type: dbCollections.PROJECTS,
        data: [{ _id: process.env.VUE_APP_SUPPORT_PROJECTID}],
    };
    const axiosData = {
        dataObj: data.data,
        dbName: process.env.VUE_APP_SUPPORT_COMPANYID,
        collection: data.type,
        methodName: "findOne",
    };
    axios.post(env.API_URI + env.MONGO_OPRATION, axiosData).then((response) => {
        selectedProject.value.push(response.data.statusText)
    });
    if(props.isSupport === true){
        allProjectsArrayFilter.value = selectedProject.value;
    }else{
        allProjectsArrayFilter.value = JSON.parse(JSON.stringify(projectsGetter.value.data))
    }
})

const scrollToBottom = () => {
    const targetDiv = document.querySelector('.task-detail-leftside');
    if (targetDiv) {
        targetDiv.scrollTo({
            top: targetDiv.scrollHeight,
            behavior: 'smooth'
        });
    }
};

const toggleSection = (key) => {
    collapsedSections.value[key] = !collapsedSections.value[key];
};

const openSection = (key) => {
    collapsedSections.value[key] = false;
};

const preserveTaskDetailScroll = (callback) => {
    const targetDiv = document.querySelector('.task-detail-leftside');
    const scrollTop = targetDiv?.scrollTop || 0;
    callback();
    nextTick(() => {
        if (targetDiv) {
            targetDiv.scrollTop = scrollTop;
        }
    });
};

const ensureCanEditKpiTask = () => {
    if (props.canEditKpiTask) return true;
    $toast.error(t("Kpi.only_assignee_or_approval_can_edit"), { position: "top-right" });
    return false;
};

const requestSubtaskCreate = () => {
    if (!ensureCanEditKpiTask()) return;
    preserveTaskDetailScroll(() => {
        openSection('subtasks');
        subtaskCreateTrigger.value += 1;
    });
};

const requestCustomFieldCreate = () => {
    if (!ensureCanEditKpiTask()) return;
    openSection('customFields');
    componentDetail.value = {};
    customFieldObject.value = {};
    isCustomField.value = true;
};

const requestChecklistCreate = () => {
    if (!ensureCanEditKpiTask()) return;
    openSection('checklist');
    checklistCreateTrigger.value += 1;
};

const requestAttachmentCreate = () => {
    if (!ensureCanEditKpiTask()) return;
    openSection('attachments');
    attachmentCreateTrigger.value += 1;
};

watch(() => props.task?._id, () => {
    collapsedSections.value.customFields = true;
    isCustomField.value = false;
    componentDetail.value = {};
    customFieldObject.value = {};
});

const newAttachments = (files) => {
    if (!ensureCanEditKpiTask()) return;
    if(!files.length) {
        return;
    }
    let fileList = Array.from(files);
    if(checkBucketStorage(fileList.map(file => file?.size),{gettersVal: getters}) !== true){
        return;
    }
    const count = ref(0);
    let isUpload = true;
    const countFun = (file) => {
        if(count.value >= fileList.length) {
            if(isUpload === true){
                $toast.success(t('Toast.Attachments_uploaded_successfully'),{position: 'top-right'});
            }else{
                $toast.error(t('Toast.Please_try_again'),{position: 'top-right'});
            }
            isSpinner.value = false;
            return;
        } else {
            isSpinner.value = true;
            let fileName = generateFileName(file.name,env.STORAGE_TYPE);
            const extension = fileName.substring(fileName.lastIndexOf(".") + 1);
            const fileType = file.type;
            const endIndex = fileType.indexOf("/");
            const result = fileType.substring(0, endIndex);

            let imagObj = {
                filename: file.name,
                extension: extension,
                size:file.size,
                id: makeUniqueId(17),
                createdAt: new Date(),
                userId: userId.value,
                type: result
            }
            const formData = new FormData();
            formData.append("companyId", companyId.value);
            if(file.type.includes("image")) {
                formData.append("key", "attachmentIcon");
            }
            formData.append("path", `Project/${props.task.ProjectID}/Sprint/${props.task._id}/Attachment/${fileName}`);
            formData.append("file", file);
            try {
                apiRequestWithoutCompnay("post", storageQueryBuilder('upload').route, formData, "form").then((response)=>{
                    if(response.data.status === true){
                        let findIndex = allProjectsArrayFilter.value.findIndex((ele)=>{return ele.id === props?.task?.ProjectID});
                        isUpload = true;
                        if(file.type.includes("image")) {
                            if(env.STORAGE_TYPE && env.STORAGE_TYPE === 'server') {
                                imagObj.url = response.data.statusText;
                            } else {
                                imagObj.url = response.data.statusText[0];
                            }
                        } else {
                            imagObj.url = response.data.statusText;
                        }
                        taskClass.updateAttachments({
                            companyId: companyId.value,
                            sprintId: props.task.sprintId,
                            taskId: props.task._id,
                            taskData: props.task,
                            operation: "add",
                            data: imagObj,
                            userData: {
                                id: user.id,
                                name: user.Employee_Name,
                                companyOwnerId: companyOwner.value._id,
                            },
                            projectData: {
                                id: findIndex == -1 ? projectData.value._id : allProjectsArrayFilter.value[findIndex]._id,
                                ProjectName: findIndex == -1 ? projectData.value.ProjectName : allProjectsArrayFilter.value[findIndex].ProjectName
                            }
                        }).then(() => {
                            count.value++;
                            countFun(fileList[count.value]);
                        }).catch((error) => {
                            console.error("Error in updating Attachment: ", error);
                            count.value++;
                            countFun(fileList[count.value]);
                        });
                    }else{
                        isUpload = false;
                        count.value++;
                        countFun(fileList[count.value]);
                        isSpinner.value = false;
                    }
                }).catch((err)=>{
                    isUpload = false;
                    count.value++;
                    countFun(fileList[count.value]);
                    isSpinner.value = false;
                    console.error(err,"Error");
                })
            } catch (error) {
                isUpload = false;
                isSpinner.value = false;
                count.value++;
                countFun(fileList[count.value]);
                console.error("Error uploading file:", error);
            }

        }
    }
    countFun(fileList[count.value]);
};

const deleteAttachments = (attachment) => {
    if (!ensureCanEditKpiTask()) return;

    Swal.fire({
        title: t(`conformationmsg.are_you_sure`),
        text: `${t('Toast.Are_you_sure_to_delete_this_file')} ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: t('Projects.cancel'),
        confirmButtonText: t('conformationmsg.yes_delete')
    }).then((result)=>{
        if (result.isConfirmed) {
            isSpinner.value = true;
            let axiousObject = storageQueryBuilder('delete',companyId.value,((env.STORAGE_TYPE && env.STORAGE_TYPE === 'server') ? (attachment.url + "&thubmkey=attachmentIcon") : attachment.url));

            apiRequest(axiousObject.method, axiousObject.route, axiousObject.data).then((response)=>{
                if(response.data.status === true){
                    let findIndex = allProjectsArrayFilter.value.findIndex((ele)=>{return ele._id === props?.task?.ProjectID});
                    taskClass.updateAttachments({
                        companyId: companyId.value,
                        sprintId: props.task.sprintId,
                        taskId: props.task._id,
                        taskData: props.task,
                        operation: "remove",
                        id: attachment.id,
                        data: attachment,
                        userData: {
                            id: user.id,
                            name: user.Employee_Name,
                            companyOwnerId: companyOwner.value._id,
                        },
                        projectData: {
                            id: findIndex == -1 ? projectData.value._id : allProjectsArrayFilter.value[findIndex]._id,
                            ProjectName: findIndex == -1 ? projectData.value.ProjectName : allProjectsArrayFilter.value[findIndex].ProjectName
                        }
                    }).then(() => {
                        isSpinner.value = false;
                        $toast.success(t('Toast.Attachment_removed_successfully'),{position: 'top-right'});
                    }).catch((error) => {
                        console.error("Error in removing Attachment: ", error);
                        $toast.error(t('Toast.Attachment_not_removed'),{position: 'top-right'});
                    })
                }else{
                    isSpinner.value = false;
                    $toast.success(t('Toast.something_went_wrong'),{position: 'top-right'});
                }
            }).catch((err)=>{
                isSpinner.value = false;
                console.error(err,"ERROR IN DELETE ATTACHMENTS");
            })
        }
    })
};
// The custom field value will be submitted to the task collection once all the validations are satisfied.
const submitHandler = async (value,detail,id,edit) => {
    if (!ensureCanEditKpiTask()) return;

    if(showCustomField.value === true){
        if(value && detail.fieldType !== 'checkbox'){
            if(detail.fieldType === 'date'){
                try{
                    detail.fieldValue = new Date(value);
                    insertCustomField(detail,value);
                } catch(error){
                    console.error('ERROR',error);
                }
            }else if(detail.fieldType === 'dropdown'){
                detail.fieldValue = [value.id];
                try {
                    insertCustomField(detail,value);
                } catch(error){
                    console.error('ERROR',error);
                }
            }else if(detail.fieldType === 'number' || detail.fieldType === 'money'){
                try{
                    detail.fieldValue = String(value);
                    insertCustomField(detail,value);
                } catch(error){
                    console.error('ERROR',error);
                }
            }else{
                nextTick(() => {
                    const input = document.getElementById(`${id}`);
                    const ariaDescribedByValue = input.getAttribute('aria-describedby');
                    if(value && ariaDescribedByValue === null){
                        try{
                            if(detail.fieldType === "phone"){
                                if(edit){
                                    detail.fieldValue = "";
                                    detail.fieldCode = value.dialCode;
                                    detail.fieldPattern = value.maskWithDialCode;
                                    detail.fieldFlag = value.code;
                                }else{
                                    detail.fieldValue = detail.fieldValue?.replace(/^\+(\d+)\s|\s|\(|\)|-/g, '');
                                    detail.fieldCode = detail.fieldCode ? detail.fieldCode : detail.fieldCountryCode;
                                    detail.fieldPattern = detail.fieldPattern ? detail.fieldPattern : detail.fieldCountryObject.maskWithDialCode;
                                    detail.fieldFlag = detail.fieldFlag ? detail.fieldFlag : detail.fieldCountryObject.code;
                                }
                            }
                            insertCustomField(detail,value);
                        } catch(error){
                            console.error('ERROR',error);
                        }
                    }
                });
            }
        } else if(detail.fieldType === 'checkbox'){
            try{
                detail.fieldValue = value;
                insertCustomField(detail,value);
            } catch(error){
                console.error('ERROR',error);
            }
        }
    }
};
const insertCustomField = (detail,data) => {
    let updateDetail = {};
    let userData = {
        id: user.id,
        name: user.Employee_Name,
        companyOwnerId: companyOwner.value._id,
    }
    updateDetail.fieldValue = detail.fieldValue;
    if(detail.fieldType === "phone"){
        updateDetail.fieldCode = detail?.fieldCode;
        updateDetail.fieldPattern = detail?.fieldPattern;
        updateDetail.fieldFlag = detail?.fieldFlag;
    }
    updateDetail._id = detail._id;
    taskClass.updateTaskCustomField({taskId: props.task._id, customFieldId: detail._id, updateDetail: updateDetail,companyId:companyId.value,taskObj:props.task,detail:detail}).then((res) => {
        if(res.status){
            let historyObj = {
                'message': `<b>${userData.name}</b> has added value in <b> ${detail.fieldTitle}</b> Custom Field as <b>${data.value ? data.value : data}</b>.`,
                'key' : 'Project_Category',
                'sprintId' : props.task.sprintId
            }
            apiRequest("post", env.HANDLE_HISTORY, {
                "type": 'task',
                "companyId": companyId.value,
                "projectId": props.task.ProjectID,
                "taskId": props.task._id,
                "object": historyObj,
                "userData": userData
            }).catch((err) =>{
                console.error("Error in updating the notification",err);
            })
            $toast.success(t("Toast.Custom_field_updated_successfully"), {position: 'top-right' });
        }else{
            $toast.error(t('Toast.something_went_wrong'), {position: 'top-right' });
        }
        submitted.value = true;
    }).catch((err)=>{
        console.error('Error in updating the custom field',err);
        $toast.error(t('Toast.something_went_wrong'), {position: 'top-right' });
    });
} 
const customFieldStore = async(object,isEdit) => {
    if (!ensureCanEditKpiTask()) return;

    let value = JSON.parse(JSON.stringify(object))
    let userData = {
        id: user.id,
        name: user.Employee_Name,
        companyOwnerId: companyOwner.value._id,
    }
    if(!isEdit){
        try {
            value.global = false;
            value.projectId = [props.task.ProjectID];
            value.createdAt = new Date();
            value.updatedAt = new Date();
            value.userId = userId.value;
            value.type = 'task'
            const object = {
                type: "save",
                updateObject:value
            }
            await apiRequest("post",env.CUSTOM_FIELD,object).then((res) => {
                if(res.status === 200) {
                    value._id = res?.data?._id || '';
                    commit("settings/mutateFinalCustomFields", {data: value || {},op: "added"});
                    $toast.success(t("Toast.Field_Added_Successfully"), {position: 'top-right' });
                    let historyObj = {
                        'message': `<b>${userData.name}</b> has Created <b> Custom Field </b> as <b>${value.fieldTitle}</b> for task.`,
                        'key' : 'Project_CustomField',
                    }
                    apiRequest("post", env.HANDLE_HISTORY, {
                        "type": 'project',
                        "companyId": companyId.value,
                        "projectId": props.task.ProjectID,
                        "taskId": null,
                        "object": historyObj,
                        "userData": userData
                    })
                }else{
                    $toast.error(t('Toast.something_went_wrong'), {position: 'top-right' });
                }
                isCustomField.value = false;
                componentDetail.value={};
                customFieldObject.value={};
            }).catch((err)=>{
                console.error("Error in inserting custom field",err);
                $toast.error(t('Toast.something_went_wrong'), {position: 'top-right' });
            });   
        } catch (error) {
            console.error("Error in inserting custom field",error);
            $toast.error(t('Toast.something_went_wrong'), {position: 'top-right' });
        }
    }else{
        try {
            const oldFieldValue = customFieldObject.value.fieldTitle
            value.updatedAt = new Date();
            const object = {
                type: "updateOne",
                key: "$set",
                updateObject:{
                    ...value
                },
                id:customFieldObject.value._id
            };
            await apiRequest("put",env.CUSTOM_FIELD,object).then((res) => {
                if(res.status === 200){
                    commit("settings/mutateFinalCustomFields", {data: {...customFieldObject.value,...value} || {},op: "modified"});
                    if(oldFieldValue !== value.fieldTitle){
                        let historyObj = {
                            'message': `<b>${userData.name}</b> has Edited <b> Custom Field </b> from <b>${oldFieldValue}</b> to <b>${value.fieldTitle}</b> for task.`,
                            'key' : 'Project_CustomField',
                        }
                        apiRequest("post", env.HANDLE_HISTORY, {
                            "type": 'project',
                            "companyId": companyId.value,
                            "projectId": props.task.ProjectID,
                            "taskId": null,
                            "object": historyObj,
                            "userData": userData
                        })
                    }
                    $toast.success(t("Toast.Field_Updated_Successfully"), {position: 'top-right' })
                }else{
                    $toast.error(t('Toast.something_went_wrong'), {position: 'top-right' });
                }
                isCustomField.value = false;
                componentDetail.value={};
                customFieldObject.value={};
            }).catch((err)=>{
                console.error("Error in updating custom field",err);
                $toast.error(t('Toast.something_went_wrong'), {position: 'top-right' });
            });   
        } catch (error) {
            console.error("Error in updating custom field",error);
            $toast.error(t('Toast.something_went_wrong'), {position: 'top-right' });
        }
    }
};
const handleCloseSidebar = (val,pageIndex) => {
    if(pageIndex === 0) isCustomField.value = val;
    componentDetail.value={};
    customFieldObject.value={};
};
function openSeeAll (value) {
    if(value === 'task'){
        emit("openSeeAll" )
    }
}
const editCustomField = (val) => {
    if (!ensureCanEditKpiTask()) return;

    if(showCustomField.value === true && currentCompany.value?.planFeature?.customFields === true){
        componentDetail.value = CustomFieldData.value.find((x)=> x.cfType === val.fieldType);
        customFieldObject.value = val;
        if(componentDetail.value && Object.keys(componentDetail.value).length){            
            isCustomField.value = true;
        }
    }
};
const handleClose = () => {
    isCustomField.value = false;
    componentDetail.value = {};
    customFieldObject.value = {};
};
</script>
<style scoped>
.task-detail-collapse-section {
    border-top: 1px solid #eef1f5;
    padding-top: 10px;
    margin-top: 10px;
}

.task-detail-collapse-header {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-height: 28px;
    padding: 0;
    color: #1f2937;
    background: transparent;
    border: 0;
    cursor: pointer;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    text-align: left;
}

.task-detail-collapse-header button {
    font-family: inherit;
}

.task-detail-collapse-header:hover {
    color: #016cd7;
}

.task-detail-collapse-caret {
    width: 14px;
    height: 14px;
    object-fit: contain;
    transition: transform 0.16s ease;
}

.task-detail-collapse-caret.is-collapsed {
    transform: rotate(-90deg);
}

.task-detail-collapse-count {
    color: #6b7280;
    font-size: 12px;
    font-weight: 500;
}

.task-detail-collapse-action {
    margin-left: auto;
    padding: 4px 8px;
    color: #016cd7;
    background: #f3f8ff;
    border: 1px solid #d9e9ff;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
}

.task-detail-collapse-action:hover {
    background: #e8f3ff;
}

.task-detail-collapse-body {
    padding-top: 8px;
}

@media(max-width: 767px) {
    .task-detail-collapse-section {
        padding: 10px;
        margin-top: 0;
        background: #fff;
        border-top: 1px solid #dfe1e6;
    }

    .task-detail-collapse-header {
        font-size: 16px;
        font-weight: 600;
    }
}
</style>
<style>

.highlighted-description{
    border: 1px solid #00dd00 !important;
}

</style>
